import Checkbox, { CheckboxProps } from './Checkbox';

export default Checkbox;
export { CheckboxProps };
